// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as JQuery from "../JQuery/index.js";
import * as Restaumatic_Holiday from "../Restaumatic.Holiday/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Utils_Elm from "../Utils.Elm/index.js";
import * as Utils_JQuery from "../Utils.JQuery/index.js";
var safeView = function (element) {
    return function (state) {
        return function (dispatch) {
            var swapClasses = function (elem) {
                return function (add) {
                    return function (remove) {
                        return function __do() {
                            JQuery.addClass(add)(elem)();
                            return JQuery.removeClass(remove)(elem)();
                        };
                    };
                };
            };
            var popoverView = function (popover) {
                return function (makeActive) {
                    return function (title) {
                        return function (desc) {
                            return function (info) {
                                return function __do() {
                                    var popoverTitle = JQuery.find(".js-restaurant-hours-popover-title")(popover)();
                                    var popoverDetails = JQuery.find(".js-restaurant-hours-popover-details")(popover)();
                                    var popoverInfo = JQuery.find(".js-restaurant-hours-popover-info")(popover)();
                                    JQuery.setHtml(title)(popoverTitle)();
                                    JQuery.setHtml(desc)(popoverDetails)();
                                    JQuery.setHtml(info)(popoverInfo)();
                                    return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)([ popoverTitle, popoverDetails, popoverInfo ])(function (x) {
                                        if (makeActive) {
                                            return swapClasses(x)("text-success")("text-danger");
                                        };
                                        return swapClasses(x)("text-danger")("text-success");
                                    })();
                                };
                            };
                        };
                    };
                };
            };
            var onCollapseShow = function (ev) {
                return function __do() {
                    var target = JQuery.getTarget(ev)();
                    var targetRoot = JQuery.closest(".js-restaurant-hours")(target)();
                    var presentDay = JQuery.find(".js-restaurant-hours-present-day")(targetRoot)();
                    var presentDayHeader = JQuery.find(".js-restaurant-hours-header")(presentDay)();
                    var presentDayData = JQuery.find(".js-restaurant-hours-data")(presentDay)();
                    var presentDayBtnPopover = JQuery.find(".js-restaurant-hours-btn-popover")(presentDay)();
                    var presentDayNow = JQuery.find(".js-restaurant-hours-now")(presentDay)();
                    var collapseBtn = JQuery.find(".js-restaurant-hours-btn-collapse")(presentDay)();
                    var caretUp = JQuery.find(".js-icon-caret-up")(collapseBtn)();
                    var caretDown = JQuery.find(".js-icon-caret-down")(collapseBtn)();
                    JQuery.addClass("invisible")(presentDayHeader)();
                    JQuery.addClass("invisible")(presentDayData)();
                    JQuery.addClass("invisible")(presentDayBtnPopover)();
                    JQuery.addClass("invisible")(presentDayNow)();
                    Utils_JQuery.hide(caretDown)();
                    return Utils_JQuery.show(caretUp)();
                };
            };
            var onCollapseHide = function (ev) {
                return function __do() {
                    var target = JQuery.getTarget(ev)();
                    var targetRoot = JQuery.closest(".js-restaurant-hours")(target)();
                    var presentDay = JQuery.find(".js-restaurant-hours-present-day")(targetRoot)();
                    var presentDayHeader = JQuery.find(".js-restaurant-hours-header")(presentDay)();
                    var presentDayData = JQuery.find(".js-restaurant-hours-data")(presentDay)();
                    var presentDayBtnPopover = JQuery.find(".js-restaurant-hours-btn-popover")(presentDay)();
                    var presentDayNow = JQuery.find(".js-restaurant-hours-now")(presentDay)();
                    var collapseBtn = JQuery.find(".js-restaurant-hours-btn-collapse")(presentDay)();
                    var caretUp = JQuery.find(".js-icon-caret-up")(collapseBtn)();
                    var caretDown = JQuery.find(".js-icon-caret-down")(collapseBtn)();
                    JQuery.removeClass("invisible")(presentDayHeader)();
                    JQuery.removeClass("invisible")(presentDayData)();
                    JQuery.removeClass("invisible")(presentDayBtnPopover)();
                    JQuery.removeClass("invisible")(presentDayNow)();
                    Utils_JQuery.hide(caretUp)();
                    return Utils_JQuery.show(caretDown)();
                };
            };
            var hoursViewNow = function (elem) {
                return function (makeActive) {
                    return function __do() {
                        var isActive = JQuery.find(".js-restaurant-hours-is-active")(elem)();
                        var isInactive = JQuery.find(".js-restaurant-hours-is-inactive")(elem)();
                        (function () {
                            if (makeActive) {
                                return Utils_JQuery.show(isActive)();
                            };
                            return Utils_JQuery.hide(isActive)();
                        })();
                        if (makeActive) {
                            return Utils_JQuery.hide(isInactive)();
                        };
                        return Utils_JQuery.show(isInactive)();
                    };
                };
            };
            var getHolidayConfig = function (elem) {
                return function __do() {
                    var holidayConfig = Utils_JQuery.getData("widget-config")(elem)();
                    var v = Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                        reflectSymbol: function () {
                            return "modifierClasses";
                        }
                    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))()))(holidayConfig));
                    if (v instanceof Data_Either.Left) {
                        var decodingErrors = Data_Foldable.foldMap(Data_List_Types.foldableNonEmptyList)(Data_Monoid.monoidString)(Foreign.renderForeignError)(v.value0);
                        var errMsg = "Element doesn't have the property data-widget-config set correctly, current value: " + (Foreign.unsafeFromForeign(holidayConfig) + ("Errors: " + decodingErrors));
                        Utils_JQuery.logErrorOnElement(errMsg)(elem)();
                        return {
                            modifierClasses: ""
                        };
                    };
                    if (v instanceof Data_Either.Right) {
                        return v.value0;
                    };
                    throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 183, column 5 - line 193, column 28): " + [ v.constructor.name ]);
                };
            };
            var upcomingHolidaysWidget = function (elem) {
                return function (upcomingHolidays) {
                    return function (v) {
                        return function __do() {
                            var content = JQuery.find(".js-upcoming-holidays-content")(elem)();
                            var $14 = Utils_JQuery.exists(content);
                            if ($14) {
                                var wrapper = Utils_JQuery.parents(".js-upcoming-holidays-wrapper")(content)();
                                var config = getHolidayConfig(wrapper)();
                                var $15 = Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(upcomingHolidays) === 0;
                                if ($15) {
                                    return Utils_JQuery.hide(wrapper)();
                                };
                                Utils_JQuery.show(wrapper)();
                                return Restaumatic_Holiday.view(config)(content)(upcomingHolidays)(dispatch)();
                            };
                            return Data_Unit.unit;
                        };
                    };
                };
            };
            var getDayIndex = function (el) {
                return function __do() {
                    var dayIndex = Utils_JQuery.getData("day")(el)();
                    var v = Control_Monad_Except.runExcept(Foreign.readInt(Data_Identity.monadIdentity)(dayIndex));
                    if (v instanceof Data_Either.Left) {
                        return 0;
                    };
                    if (v instanceof Data_Either.Right) {
                        return v.value0;
                    };
                    throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 171, column 5 - line 173, column 40): " + [ v.constructor.name ]);
                };
            };
            var getDataString = function (elem) {
                return function (classesType) {
                    return function __do() {
                        var classesData = Utils_JQuery.getData(classesType)(elem)();
                        var v = Control_Monad_Except.runExcept(Foreign.readString(Data_Identity.monadIdentity)(classesData));
                        if (v instanceof Data_Either.Left) {
                            return "";
                        };
                        if (v instanceof Data_Either.Right) {
                            return v.value0;
                        };
                        throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 198, column 5 - line 200, column 28): " + [ v.constructor.name ]);
                    };
                };
            };
            var findByClassIncludeSelf = function (className) {
                return function (elem) {
                    return function __do() {
                        var children = JQuery.find(className)(elem)();
                        var childrenWithRoot = Utils_JQuery.addBack(children)();
                        return Control_Bind.bind(Effect.bindEffect)(Utils_JQuery.filter(className)(childrenWithRoot))(Control_Applicative.pure(Effect.applicativeEffect))();
                    };
                };
            };
            var hoursViewAllDays = function (elem) {
                return function __do() {
                    var allDaysWrapper = findByClassIncludeSelf(".js-restaurant-hours-all-days")(elem)();
                    var days = JQuery.find(".js-restaurant-hours-day")(allDaysWrapper)();
                    var daysArr = JQuery.toArray(days)();
                    return Effect.foreachE(daysArr)(function (x) {
                        return function __do() {
                            var otherDaysPopoverBtn = JQuery.find(".js-restaurant-hours-btn-popover")(x)();
                            var otherDaysNow = JQuery.find(".js-restaurant-hours-now")(x)();
                            Utils_JQuery.hide(otherDaysPopoverBtn)();
                            return Utils_JQuery.hide(otherDaysNow)();
                        };
                    })();
                };
            };
            var hoursViewPresentDay = function (elem) {
                return function (makeActive) {
                    return function (dayHours) {
                        return function __do() {
                            var activeClasses = getDataString(elem)("active-classes")();
                            var inactiveClasses = getDataString(elem)("inactive-classes")();
                            var presentDayWrapper = findByClassIncludeSelf(".js-restaurant-hours-present-day")(elem)();
                            var presentDayData = JQuery.find(".js-restaurant-hours-data")(presentDayWrapper)();
                            JQuery.setHtml(dayHours)(presentDayData)();
                            if (makeActive) {
                                return swapClasses(presentDayWrapper)(activeClasses)(inactiveClasses)();
                            };
                            return swapClasses(presentDayWrapper)(inactiveClasses)(activeClasses)();
                        };
                    };
                };
            };
            var hoursViewToday = function (elem) {
                return function (makeActive) {
                    return function (dayIndex) {
                        return function __do() {
                            var activeClasses = getDataString(elem)("active-classes")();
                            var inactiveClasses = getDataString(elem)("inactive-classes")();
                            var allDaysWrapper = findByClassIncludeSelf(".js-restaurant-hours-all-days")(elem)();
                            var days = JQuery.find(".js-restaurant-hours-day")(allDaysWrapper)();
                            var daysArr = JQuery.toArray(days)();
                            var todayElems = Data_Array.filterA(Effect.applicativeEffect)(function (x) {
                                return function __do() {
                                    var day = Utils_JQuery.getData("day")(x)();
                                    var v = Control_Monad_Except.runExcept(Foreign.readInt(Data_Identity.monadIdentity)(day));
                                    if (v instanceof Data_Either.Left) {
                                        return false;
                                    };
                                    if (v instanceof Data_Either.Right) {
                                        return v.value0 === dayIndex;
                                    };
                                    throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 242, column 11 - line 244, column 60): " + [ v.constructor.name ]);
                                };
                            })(daysArr)();
                            var v = Data_Array.head(todayElems);
                            if (v instanceof Data_Maybe.Just) {
                                var todayPopoverBtn = JQuery.find(".js-restaurant-hours-btn-popover")(v.value0)();
                                var todayNow = JQuery.find(".js-restaurant-hours-now")(v.value0)();
                                Utils_JQuery.show(todayPopoverBtn)();
                                Utils_JQuery.show(todayNow)();
                                if (makeActive) {
                                    return swapClasses(v.value0)(activeClasses)(inactiveClasses)();
                                };
                                return swapClasses(v.value0)(inactiveClasses)(activeClasses)();
                            };
                            if (v instanceof Data_Maybe.Nothing) {
                                return Data_Unit.unit;
                            };
                            throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 247, column 5 - line 255, column 27): " + [ v.constructor.name ]);
                        };
                    };
                };
            };
            var onlineHoursView = function (elem) {
                return function (av) {
                    return function __do() {
                        hoursViewNow(elem)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isOnlinePossible";
                            }
                        })())(Data_Symbol.SProxy.value)(av))();
                        hoursViewPresentDay(elem)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isOnlinePossible";
                            }
                        })())(Data_Symbol.SProxy.value)(av))(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "onlineHoursString";
                            }
                        })())(Data_Symbol.SProxy.value)(av))();
                        hoursViewAllDays(elem)();
                        hoursViewToday(elem)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isOnlinePossible";
                            }
                        })())(Data_Symbol.SProxy.value)(av))(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "onlineDayIndex";
                            }
                        })())(Data_Symbol.SProxy.value)(av))();
                        var popover = JQuery.find(".js-restaurant-hours-popover")(elem)();
                        var title = (function () {
                            var $29 = Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "isOnlinePossible";
                                }
                            })())(Data_Symbol.SProxy.value)(av);
                            if ($29) {
                                return Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "active";
                                    }
                                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "hours";
                                    }
                                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "restaurants";
                                    }
                                })())(Data_Symbol.SProxy.value)(Restaumatic_Site_Translations_Keys.t))));
                            };
                            return Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "inactive";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "hours";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "restaurants";
                                }
                            })())(Data_Symbol.SProxy.value)(Restaumatic_Site_Translations_Keys.t))));
                        })();
                        var info = Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "holidaysInfo";
                            }
                        })())(Data_Symbol.SProxy.value)(av);
                        var desc = (function () {
                            var $30 = Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "holidaysHoursString";
                                }
                            })())(Data_Symbol.SProxy.value)(av) === "";
                            if ($30) {
                                return "";
                            };
                            return Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "holidays";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "hours";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "restaurants";
                                }
                            })())(Data_Symbol.SProxy.value)(Restaumatic_Site_Translations_Keys.t)))) + (": " + Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "holidaysHoursString";
                                }
                            })())(Data_Symbol.SProxy.value)(av));
                        })();
                        return popoverView(popover)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isOnlinePossible";
                            }
                        })())(Data_Symbol.SProxy.value)(av))(title)(desc)(info)();
                    };
                };
            };
            var openingHoursView = function (elem) {
                return function (av) {
                    return function __do() {
                        hoursViewNow(elem)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isRestaurantOpen";
                            }
                        })())(Data_Symbol.SProxy.value)(av))();
                        hoursViewPresentDay(elem)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isRestaurantOpen";
                            }
                        })())(Data_Symbol.SProxy.value)(av))(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "openingHoursString";
                            }
                        })())(Data_Symbol.SProxy.value)(av))();
                        hoursViewAllDays(elem)();
                        hoursViewToday(elem)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isRestaurantOpen";
                            }
                        })())(Data_Symbol.SProxy.value)(av))(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "openingDayIndex";
                            }
                        })())(Data_Symbol.SProxy.value)(av))();
                        var popover = JQuery.find(".js-restaurant-hours-popover")(elem)();
                        var title = (function () {
                            var $31 = Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "isRestaurantOpen";
                                }
                            })())(Data_Symbol.SProxy.value)(av);
                            if ($31) {
                                return Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "open";
                                    }
                                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "hours";
                                    }
                                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "restaurants";
                                    }
                                })())(Data_Symbol.SProxy.value)(Restaumatic_Site_Translations_Keys.t))));
                            };
                            return Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "closed";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "hours";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "restaurants";
                                }
                            })())(Data_Symbol.SProxy.value)(Restaumatic_Site_Translations_Keys.t))));
                        })();
                        var info = Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "holidaysInfo";
                            }
                        })())(Data_Symbol.SProxy.value)(av);
                        var desc = (function () {
                            var $32 = Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "holidaysHoursString";
                                }
                            })())(Data_Symbol.SProxy.value)(av) === "";
                            if ($32) {
                                return "";
                            };
                            return Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "holidays";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "hours";
                                }
                            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "restaurants";
                                }
                            })())(Data_Symbol.SProxy.value)(Restaumatic_Site_Translations_Keys.t)))) + (": " + Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "holidaysHoursString";
                                }
                            })())(Data_Symbol.SProxy.value)(av));
                        })();
                        return popoverView(popover)(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "isRestaurantOpen";
                            }
                        })())(Data_Symbol.SProxy.value)(av))(title)(desc)(info)();
                    };
                };
            };
            return function __do() {
                var elementsArr = JQuery.toArray(element)();
                Utils_Elm.onInit(element)(function __do() {
                    var body = JQuery.select("body")();
                    JQuery.on("show.bs.collapse")(function (ev) {
                        return function (el) {
                            return onCollapseShow(ev);
                        };
                    })(body)();
                    JQuery.on("hide.bs.collapse")(function (ev) {
                        return function (el) {
                            return onCollapseHide(ev);
                        };
                    })(body)();
                    var slugs = Data_Traversable.traverse(Data_Traversable.traversableArray)(Effect.applicativeEffect)(function (el) {
                        return Control_Bind.bind(Effect.bindEffect)(Utils_JQuery.getAttr("data-restaurant-slug")(el))(Control_Applicative.pure(Effect.applicativeEffect));
                    })(elementsArr)();
                    var slugsUniq = Data_Array.filterA(Effect.applicativeEffect)(function (x) {
                        return Control_Applicative.pure(Effect.applicativeEffect)(!(x === ""));
                    })(Data_Array.nub(Data_Ord.ordString)(slugs))();
                    return JQuery.ready(Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(slugsUniq)(function (slug) {
                        return dispatch({
                            type: "GET_RESTAURANT_HOURS",
                            payload: {
                                slug: slug
                            }
                        });
                    }))();
                })();
                return Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableArray)(elementsArr)(function (elem) {
                    return function __do() {
                        var slug = Utils_JQuery.getAttr("data-restaurant-slug")(elem)();
                        var v = Data_Foldable.find(Data_Foldable.foldableArray)(function (x) {
                            return Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "slug";
                                }
                            })())(Data_Symbol.SProxy.value)(x) === slug;
                        })(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "restaurantsAvailability";
                            }
                        })())(Data_Symbol.SProxy.value)(state));
                        if (v instanceof Data_Maybe.Just) {
                            var openingHoursWrapper = findByClassIncludeSelf(".js-restaurant-hours-opening")(elem)();
                            openingHoursView(openingHoursWrapper)(v.value0)();
                            var onlineHoursWrapper = findByClassIncludeSelf(".js-restaurant-hours-online")(elem)();
                            onlineHoursView(onlineHoursWrapper)(v.value0)();
                            return upcomingHolidaysWidget(elem)(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "upcomingHolidays";
                                }
                            })())(Data_Symbol.SProxy.value)(v.value0))(dispatch)();
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return Data_Unit.unit;
                        };
                        throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 67, column 5 - line 75, column 27): " + [ v.constructor.name ]);
                    };
                })();
            };
        };
    };
};
var view = function (element) {
    return function (fstate) {
        return function (dispatch) {
            var v = Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "restaurantsAvailability";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "upcomingHolidays";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "info";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "duration";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "description";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))()))))())({
                reflectSymbol: function () {
                    return "slug";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "phoneHoursString";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "phoneDayIndex";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
                reflectSymbol: function () {
                    return "openingHoursString";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "openingDayIndex";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
                reflectSymbol: function () {
                    return "onlineHoursString";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "onlineDayIndex";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
                reflectSymbol: function () {
                    return "isRestaurantOpen";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
                reflectSymbol: function () {
                    return "isPhonePossible";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
                reflectSymbol: function () {
                    return "isOnlinePossible";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
                reflectSymbol: function () {
                    return "holidaysInfo";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
                reflectSymbol: function () {
                    return "holidaysHoursString";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))()))))()))(fstate));
            if (v instanceof Data_Either.Right) {
                return safeView(element)(v.value0)(dispatch);
            };
            if (v instanceof Data_Either.Left) {
                var decodingErrors = Data_Foldable.foldMap(Data_List_Types.foldableNonEmptyList)(Data_Monoid.monoidString)(Foreign.renderForeignError)(v.value0);
                var errMsg = "Incorrect data passed to RestaurantHours view, " + ("Errors: " + decodingErrors);
                return Effect_Exception["throw"](errMsg);
            };
            throw new Error("Failed pattern match at Components.RestaurantHoursPS (line 42, column 3 - line 50, column 19): " + [ v.constructor.name ]);
        };
    };
};
export {
    init,
    update
} from "./foreign.js";
export {
    view,
    safeView
};
//# sourceMappingURL=index.js.map
